import { Controller } from "@hotwired/stimulus"

// Native confirm() for a form that opts out of Turbo (data-turbo="false").
// Turbo's own data-turbo-confirm handling only runs for forms Turbo actually
// intercepts, so a plain-navigation form (see customer/reservations/_cancel_panel)
// needs its own submit-time confirmation instead.
export default class extends Controller {
  static values = { message: String }

  check(event) {
    if (!window.confirm(this.messageValue)) {
      event.preventDefault()
    }
  }
}
